import UserFull from "@/vuex/models/user/user-full";

export default class AuthState {
    public token!: string | null;
    public me!: UserFull | null;
}
